import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import FilterPanel from "./FilterPanel";
import { FilterState } from "./filterTypes";

interface FilterSidebarProps {
  isOpen: boolean;
  onClose: () => void;
  filters: FilterState;
  onFilterChange: (newFilters: FilterState) => void;
  airlines: string[];
  priceRange: { min: number; max: number };
}

const FilterSidebar: React.FC<FilterSidebarProps> = ({
  isOpen,
  onClose,
  filters,
  onFilterChange,
  airlines,
  priceRange,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className="fixed inset-0 bg-black/20 z-40"
            onClick={onClose}
          />

          {/* Sidebar */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className="fixed right-4 top-4 h-[calc(100vh-2rem)] w-80 bg-white rounded-lg shadow-lg z-50"
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 sticky top-0">
              <h2 className="text-lg font-semibold text-neutral-800">
                Filters
              </h2>
              <button
                onClick={onClose}
                className="p-1.5 hover:bg-neutral-100 rounded-full transition-colors"
              >
                <X className="w-5 h-5 text-neutral-500" />
              </button>
            </div>

            {/* Filter Content */}
            <div className="h-[calc(100vh-8rem)] overflow-y-auto">
              <FilterPanel
                filters={filters}
                onFilterChange={onFilterChange}
                airlines={airlines}
                priceRange={priceRange}
              />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default FilterSidebar;
